export const days = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

export const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const PRIZES = "all-prizes";

export const sizing = {
  SIZES: "all-sizes",
  SMALL: "small",
  MEDIUM: "medium",
  BIG: "big",
};

export const values = {
  CHEAP: "Económico",
  CONFORT: "Confort",
  MAGNIFICENT: "Magnífico",
  LUXURY: "Lujo",
};

export const locations = {
  ALLCOUNTRIES: "all-countries",
  ARG: "argentina",
  CHL: "chile",
  URU: "uruguay",
  BRA: "brasil",
};